/* eslint-disable @trello/export-matches-filename */

import type {
  ActionType,
  Trigger,
  TriggerType,
} from '@atlassian/butler-command-parser';
import { freeze } from '@trello/objects';

import type { TriggerMetadata } from './types';
import { ActionContext, CommandElementCategory } from './types';

export const TRIGGER_METADATA = freeze<
  Partial<Record<TriggerType, TriggerMetadata>>
>({
  CARD_INTO_LIST: {
    category: CommandElementCategory.CardsAndLists,
    commandType: 'rule',
    providedContext: [ActionContext.Card, ActionContext.List],
    actionsBlockList: ['SORT_LIST_ACTION'],
  },
  EVERY_DAY: {
    category: CommandElementCategory.Calendar,
    commandType: 'schedule',
  },
  CERTAIN_DAYS: {
    category: CommandElementCategory.Calendar,
    commandType: 'schedule',
  },
});

export const getTriggerType = (trigger?: Trigger): TriggerType | null =>
  trigger?.[trigger.type]?.type ?? null;

export const getTriggerMetadata = (
  trigger?: Trigger,
): TriggerMetadata | null => {
  const triggerType = getTriggerType(trigger);
  if (triggerType) {
    return TRIGGER_METADATA[triggerType] ?? null;
  }
  return null;
};

export const getActionBlockListForTrigger = (
  trigger?: Trigger,
): ActionType[] => {
  const triggerType = getTriggerType(trigger);
  if (triggerType) {
    return TRIGGER_METADATA[triggerType]?.actionsBlockList ?? [];
  }
  return [];
};
